import { UIHeading2, UIHeading5 } from '@cian/ui-kit/typography';
import cn from 'classnames';
import * as React from 'react';

import * as styles from './Info.css';
import { formatPrice } from './utils';
import { IDailyRentOfferForMobileSite } from '../../../../repositories/dailyrent/entities/daily_rent_offers_for_web/DailyRentOfferForMobileSite';
import { Price } from '../Price';

const Feature = ({ name, separator }: { name?: string | null; separator: boolean }) => (
  <>
    <UIHeading5 data-name="Feature" display="inline">
      {name}
    </UIHeading5>
    {separator && <span className={styles['separator']} data-name="FeatureSeparator" />}
  </>
);

interface IInfoProps extends Pick<
  IDailyRentOfferForMobileSite,
  'price' | 'features' | 'isHotel' | 'starRating' | 'vasTitle' | 'discount'
> {
  hasRating?: boolean;
  isCompact?: boolean;
  hasDates: boolean;
}

export const Info = (props: IInfoProps) => {
  const { price, features, hasRating, hasDates, isCompact, isHotel, starRating, vasTitle, discount } = props;

  const featuresList = [features.objectType, features.totalArea, features.floorInfo].filter(Boolean);

  const { percent, oldPrice } = discount || {};
  const formattedPrice = hasDates ? formatPrice(price) : 'от ' + formatPrice(price);

  if (isHotel) {
    const hotelTitle = starRating ? (
      <>
        {vasTitle}&nbsp;{starRating}&nbsp;
        <span className={styles['star']} />
      </>
    ) : (
      vasTitle
    );

    return (
      <div className={cn(styles['container'], !hasRating && styles['container_extra-margin'])}>
        <span className={styles['price']}>
          <UIHeading2>{formattedPrice}</UIHeading2>
        </span>
        {Boolean(vasTitle) && (
          <span className={styles['vas-title']}>
            <UIHeading5>{hotelTitle}</UIHeading5>
          </span>
        )}
      </div>
    );
  }

  return (
    <div className={cn(styles['container'], !hasRating && styles['container_extra-margin'])}>
      <Price
        className={styles['price']}
        price={formattedPrice}
        originalPrice={oldPrice}
        discountPercent={percent}
        isCompact={isCompact}
      />
      <span className={styles['stats']}>
        {featuresList.map((name, idx) => (
          <Feature key={`feature-${idx}`} name={name} separator={idx < featuresList.length - 1} />
        ))}
      </span>
    </div>
  );
};
